export { SAVE_URL_PARAMS } from 'Reducers/compModels/reader';

export const EXTRACT_AND_MODIFY_URL = 'EXTRACT_AND_MODIFY_URL';
